<template>
  <!-- PAGE HEADER: Location Inspection Listing -->
  <div class="row">
    <div class="col">
      <ZFilterHeader :title="firmName" :isRouteHome="true" :isDateRange="true" :startDate="dashboardDateRange.startDate"
        :endDate="dashboardDateRange.endDate" :isFilter="false" :isFetching="isFetching" :restriction="dateRestriction"
        routeTo="/dashboard" @datesChanged="datesChanged" @refresh="refresh" />
    </div>
  </div>
  <!-- HEADER: Location Service Details -->
  <!-- <div class="row pb-2">
    <div class="col">
      <RNServiceSummary />
    </div>
  </div> -->
  <!-- HEADER: Location Inspection Listing -->
  <div class="row d-none d-md-block">
    <div class="col pt-2">
      <ZTableHeader :headerProps="headerProps" :listParams="gridParams" :showTitle="false" @search="search"
        @updateParams="updateParams" />
    </div>
  </div>
  <!-- TABLE LISTING: Location Inspection Listing -->
  <div class="row d-none d-md-block">
    <div v-if="isFetching">
      <span>loading...</span>
    </div>
    <div v-else class="col dashboard-data-table">
      <ZTable v-model="tableData" class="table table-bordered table-striped" :is-single-row-detail="false"
        :is-header-fixed="true" :columns="tableHeader" @sort="setOrder">
        <template #tbody="props">
          <td class="custom-column-60-center custom-view-link">
            <button class="btn btn-link" @click="viewRecord(props.row)">view</button>
          </td>
          <td>{{ props.row.adasInspection }}</td>
          <td>{{ props.row.ronumber }}</td>
          <td>
            <div class="custom-vehicle">
              <span>{{ props.row.vin }}</span>
              <span class="custom-vehicle-info">{{ setVehicle(props.row) }}</span>
            </div>
          </td>
          <td>{{ formatDate(props.row.deliveryDate) }}</td>
          <td class="text-center">{{ props.row.numberSystems }}</td>
          <td class="text-center">{{ props.row.numberServices }}</td>
          <!-- <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td>
          <td class="text-center">
            <i class="fa-solid fa-circle" :class="getServiceStatus(props.row)"></i>
          </td> -->
        </template>
        <template #empty> Nothing found! </template>
      </ZTable>
    </div>
  </div>
  <!-- ------------------------------------------------- -->
  <!-- CARD VIEW (NOT USED): Location Inspection Listing -->
  <div class="row d-block d-md-none">
    <div class="shop-card">
      <!-- HEADER: Location Inspections -->
      <ZHeader :headerProps="headerProps" :listParams="gridParams" :isPaginated="false" :showTitle="false"
        @updateParams="updateParams" @search="search" />
      <!-- CARDS: Location Inspections -->
      <div class="row m-0 dashboard-shop-card">
        <div v-if="!cardData">
          <Loader singleCard="true" />
        </div>
        <div v-if="cardData && cardData !== 'noData'" class="row">
          <div v-for="(item, idx) of cardData" :key="idx" class="col-12 col-sm-6 col-md-3 shop-list-container p-2">
            <div class="shop-list-div p-3">
              <div class="shop-header-mobile pb-3 d-flex justify-content-between">
                <div>
                  <p class="shop-name-mobile colorPrimary text-start fw-6 fs-16 m-0">
                    {{ item.vin }}
                  </p>
                  <p class="colorPrimary text-start m-0 fs-12">{{ item.model }}</p>
                </div>
                <div>
                  <button class="btn router-image-btn collapsed" type="button" data-bs-toggle="collapse"
                    :data-bs-target="'#expandDiv' + idx" aria-expanded="false">
                    <span class="sd-expand">Expand <i class="fa fa-angle-down" aria-hidden="true"></i></span>
                    <span class="sd-collapse">Collapse <i class="fa fa-angle-up" aria-hidden="true"></i></span>
                  </button>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0">#Ro</p>
                  <p class="shop-service-required-mobile fs-14 colorPrimary text-start fw-b m-0">
                    {{ item.ronumber }}
                  </p>
                </div>
                <div>
                  <p class="text-start fs-12 colorPrimary m-0"># of ADAS System</p>
                  <p class="shop-service-completed-mobile text-start fs-14 colorPrimary fw-b m-0">
                    {{ item.numberSystems }}
                  </p>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0">Delivery Date</p>
                  <p class="shop-service-required-mobile fs-14 colorPrimary text-start fw-b m-0">
                    {{ formatDate(item.deliveryDate) }}
                  </p>
                </div>
                <div>
                  <p class="text-start fs-12 colorPrimary m-0"># of Required Services</p>
                  <p class="shop-service-completed-mobile text-start fs-14 colorPrimary fw-b m-0">
                    {{ item.numberServices }}
                  </p>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0 btn btn-link" @click="viewRecord(item)">View</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="cardData === 'noData'">
          <Loader singleEmptyCard="true" />
        </div>
      </div>
    </div>
  </div>
  <!-- ------------------------------------------------- -->
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import ZFilterHeader from '@/components/utilities/elements/FilterHeader.vue'
import ZTableHeader from '@/components/utilities/elements/TableHeader.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
import RNServiceSummary from '@/components/dashboard/repairNetwork/RN_ServiceSummary.vue'
import ZHeader from '@/components/utilities/elements/TableHeader.vue'
import moment from 'moment'
import Loader from '@/components/utilities/elements/Loader.vue'
export default {
  name: 'ServiceDetails',
  components: {
    ZFilterHeader,
    ZTableHeader,
    ZTable,
    RNServiceSummary,
    ZHeader,
    Loader
  },
  data() {
    return {
      headerProps: {
        pageSizes: [
          { name: '10', value: 10 },
          { name: '25', value: 25 },
          { name: '50', value: 50 },
          { name: '100', value: 100 }
        ],
        title: null,
        subtitle: null,
        isTitle: false,
        isPaginated: true,
        isChecked: false,
        isAdd: false,
        isDelete: false,
        toggleButtons: null,
        buttons: null
      },
      tableHeader: [
        { field: 'adasInspection', label: '', sortable: false, class: 'custom-column-60-center' },
        { field: 'adasInspection', label: '#', sortable: true },
        { field: 'ronumber', label: 'RO#', sortable: true },
        { field: 'vin', label: 'VIN, Year/Make/Model', sortable: true },
        {
          field: 'deliveryDate',
          label: 'Delivered',
          // style: 'position: relative; width: 80%;',
          // html: '<span>Delivered</span><i class="fas fa-circle-info table-header-info"></i>',
          sortable: true
        },
        { field: 'numberSystems', label: '# ADAS Systems', sortable: false, class: 'text-center' },
        { field: 'numberServices', label: '# Required', sortable: false, class: 'text-center' }
        // { field: 'prescan', label: 'Pre-Scan', sortable: false },
        // { field: 'inprogress', label: 'In Progress', sortable: false },
        // { field: 'calibrations', label: 'Calibrations', sortable: false },
        // { field: 'postscan', label: 'Post-Scan', sortable: false },
        // { field: 'validation', label: 'Validation', sortable: false }
      ],
      cnt: 0,
      dateRestriction: 365 // 7 days
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(dashboardStore, ['inspectionData', 'firm', 'startDate', 'endDate', 'selectedInsurer', 'isFetching', 'gridParams', 'isRefresh']),
    tableData() {
      let _data = []
      if (this.inspectionData) {
        if (this.inspectionData !== 'noData') {
          _data = this.inspectionData.items
        }
      }
      return _data
    },
    cardData() {
      let _data = []
      if (this.inspectionData) {
        if (this.inspectionData !== 'noData') {
          _data = this.inspectionData.items
        }
      }
      return _data
    },
    tableCount() {
      let _data = null
      if (this.inspectionData) {
        _data = this.inspectionData.count ? this.inspectionData.count : 0
        this.updateParams({
          name: 'count',
          value: _data
        })
      }
      return _data
    },
    dashboardDateRange() {
      return {
        startDate: this.startDate,
        endDate: this.endDate
      }
    },
    firmName() {
      let _data = null
      if (this.firm) {
        _data = this.firm.name
      }
      return _data
    },
    source() {
      let _data = null
      if (this.firm) {
        _data = this.firm.source
      }
      return _data
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['getLocationInspections', 'getServicesDetail', 'setDate', 'sortArray', 'setRefresh', 'setGridParam', 'resetData']),
    async init() {
      console.log('Initializing Service Details...', {
        firm: this.firm,
        selectedInsurer: this.selectedInsurer,
        startDate: this.startDate,
        endDate: this.endDate
      })
      await this.fetchServicesDetail()
      await this.fetchInspections()
    },
    async fetchInspections() {
      let data = {
        firm: this.firm.firm,
        startDate: this.startDate,
        endDate: this.endDate,
        search: this.gridParams.searchTerm,
        page: parseInt(this.gridParams.page) - 1,
        pageSize: this.gridParams.pageSize,
        orderBy: this.gridParams.orderBy,
        sortBy: this.gridParams.sortBy,
        source: this.source,
        selectedInsurer: this.selectedInsurer ? this.selectedInsurer : null
      }
      await this.getLocationInspections(data)
      this.updateParams({
        name: 'count',
        value: this.inspectionData ? this.inspectionData.count : 0
      })
    },
    async fetchServicesDetail() {
      let data = {
        firm: this.firm.firm,
        startDate: this.startDate,
        endDate: this.endDate,
        source: this.source
      }
      console.log('Calling for Client Services Detail...', {
        firm: this.firm,
        data: data
      })
      await this.getServicesDetail(data)
    },
    async setOrder(column, sortBy) {
      this.gridParams.page = 1
      this.gridParams.sortBy = sortBy
      this.gridParams.orderBy = column.field
      await this.fetchInspections()
    },
    updateParams(data) {
      switch (data.name) {
        case 'page':
          this.gridParams.page = data.value
          break
        case 'count':
          this.gridParams.numItems = data.value
          break
      }
    },
    datesChanged(data) {
      console.log('Dates Changed...', data)
      this.setDate(data.name, data.value)
    },
    async refresh(forceRefresh) {
      if (forceRefresh) {
        this.setGridParam({
          name: 'page',
          value: 1
        })
        this.setRefresh(true)
      }
      if (this.isRefresh) {
        console.log('Refreshing...')
        this.resetData('all')
        await this.fetchServicesDetail()
        await this.fetchInspections()
        this.setRefresh(false)
      }
    },
    search(data) {
      if (data.reset) {
        this.updateParams({
          name: 'page',
          value: 1
        })
      }
      console.log('Searching...', {
        data: data,
        currentParams: this.gridParams
      })
      this.resetData('inspections')
      this.fetchInspections()
    },
    formatDate(data) {
      let result = null
      if (data) {
        result = moment(data).format('MM/DD/YYYY')
      }
      return result
    },
    setVehicle(data) {
      return `${data.year} ${data.make} ${data.model}`
    },
    viewRecord(data) {
      console.log('View Record...', data)
      router.push(`/vehicle-details/${data.vin}/${data.adasInspection}/location`)
    },
    getServiceStatus() {
      let rndClass = null
      let min = 1
      let max = 4
      let rndInt = Math.floor(Math.random() * (max + 1 - min) + min)
      switch (rndInt) {
        case 1:
          rndClass = 'custom-color-green'
          break
        case 2:
          rndClass = 'custom-color-red'
          break
        case 3:
          rndClass = 'custom-color-yellow'
          break
        case 4:
          rndClass = 'custom-color-grey'
          break
      }
      return rndClass
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-vehicle {
  width: 100%;
  display: grid;
}

.custom-vehicle-info {
  font-size: 0.8em;
}

.custom-view-link {
  cursor: pointer;
}

.custom-color-codes {
  float: right;
  padding-right: 15px;
}

.custom-color-green {
  color: green;
}

.custom-color-red {
  color: red;
}

.custom-color-yellow {
  color: yellow;
}

.custom-color-grey {
  color: grey;
}

.dashboard-shop-card {
  max-height: 560px;
  overflow: auto;
}

.shop-list-container:nth-child(even) {
  background-color: #fcfcfd;
}

.shop-list-div:hover {
  background-color: rgb(97 169 36 / 10%);
  cursor: pointer;
}

.shop-list-div {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 10px;
}

.shop-header-mobile {
  border-bottom: 1px solid var(--bs-border-color-translucent);
}

.router-image-btn.collapsed .sd-collapse {
  display: none;
}

.router-image-btn .sd-collapse {
  display: block;
}

.router-image-btn.collapsed .sd-expand {
  display: block;
}

.router-image-btn .sd-expand {
  display: none;
}
</style>
